/* eslint-disable @typescript-eslint/no-var-requires */
export const hotelLogoQuery = require('./hotel-logo.graphql');
export const propertyBarQuery = require('./property-bar.graphql');
export const propertyBarAuthQuery = require('./property-bar-auth.graphql');
